import cx from 'classnames'
import { TikTokIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import { highlightContent } from '../highlightContent'
import { Button } from 'blaze-ui/Button'
import { Edit1 } from 'blaze-ui/icons'
import { CaptionSkeleton } from '../components/CaptionSkeleton/CaptionSkeleton'
import { useTruncateText } from '../hooks/useTruncateText'
import { MoreButton } from '../InstagramReelPreview/Footer'
import Styles from './TikTokPreview.module.scss'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'

interface FooterProps {
  integration?: TikTokIntegration
  content?: string
  onEdit?: () => void
  isGenerating?: boolean
  alwaysTruncateCaption?: boolean
  post?: ScheduledPostShow
}

export const Footer = ({
  integration,
  content,
  post,
  onEdit,
  isGenerating = false,
  alwaysTruncateCaption = false,
}: FooterProps) => {
  const { name } = integration ? extractProfileInfo(integration) : { name: 'User' }

  const highlightClassNames = {
    mentionClassName: Styles.highlight,
    hashtagClassName: Styles.highlight,
  }

  const { isTruncated, setIsTruncated, shouldShowMoreButton, textRef } = useTruncateText({
    content: content || '',
    truncatedByDefault: alwaysTruncateCaption,
  })

  const showMoreButton = content && shouldShowMoreButton
  const postContent = post?.scheduled_post_targets.find((target) => target.provider === ExternalIntegrationEnum.TikTok)
    ?.target_overrides?.content

  return (
    <div className={Styles.footer}>
      <div className={Styles.nameAndCaption}>
        <div className={Styles.username}>{`@${name}`}</div>
        {onEdit && (
          <Button variant="tertiary" onPress={onEdit} frontIcon={Edit1}>
            Edit
          </Button>
        )}
        <div className={Styles.caption}>
          {isGenerating ? (
            <CaptionSkeleton />
          ) : (
            <>
              <span
                ref={textRef as React.RefObject<HTMLSpanElement>}
                key={`caption-${content || ''}`}
                className={cx({ [Styles.truncated]: isTruncated })}
                dangerouslySetInnerHTML={{
                  __html: highlightContent(postContent || content || '', highlightClassNames),
                }}
              />
              {showMoreButton && !alwaysTruncateCaption && isTruncated && (
                <MoreButton isTruncated={isTruncated} setIsTruncated={setIsTruncated} />
              )}
            </>
          )}
        </div>
        {!isGenerating && showMoreButton && !alwaysTruncateCaption && !isTruncated && (
          <div className={Styles.lessButton}>
            <MoreButton isTruncated={isTruncated} setIsTruncated={setIsTruncated} />
          </div>
        )}
      </div>
    </div>
  )
}
